import { render, staticRenderFns } from "./CustomerRecordModal.vue?vue&type=template&id=278fbd5e&scoped=true&"
import script from "./CustomerRecordModal.vue?vue&type=script&lang=js&"
export * from "./CustomerRecordModal.vue?vue&type=script&lang=js&"
import style0 from "./CustomerRecordModal.vue?vue&type=style&index=0&id=278fbd5e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "278fbd5e",
  null
  
)

export default component.exports